import { render, staticRenderFns } from "./stackView.vue?vue&type=template&id=1522621a&scoped=true"
import script from "./stackView.vue?vue&type=script&lang=js"
export * from "./stackView.vue?vue&type=script&lang=js"
import style0 from "./stackView.vue?vue&type=style&index=0&id=1522621a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1522621a",
  null
  
)

export default component.exports